import React, {useEffect, useRef} from 'react';
import './Template.scss';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-quill/dist/quill.snow.css'
 import { IoMdArrowBack } from "react-icons/io";
import { useLocation, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2'
import { IoIosAdd } from "react-icons/io";
 import { FaMailBulk } from "react-icons/fa";
  import ReactQuill from 'react-quill';

function MyTemplate() {

    const baseURL =
    process.env.NODE_ENV === 'production'
      ? process.env.REACT_APP_API_URL_PROD
      : process.env.REACT_APP_API_URL_LOCAL;

       const navigate = useNavigate("")
         const [templates, setTemplates] = useState([]);
         const location = useLocation();
           const dropdownRef = useRef(null);
            const [showDropdown, setShowDropdown] = useState(false);
              const [isOpen, setIsOpen] = useState(false);
             const openModal = () => setIsOpen(true);
               const closeModal = () => setIsOpen(false);
          const popupRef = useRef(null);
           const [templateName, setTemplateName] = useState('');
             const [templateMessage, setTemplateMessage] = useState("");
                const quillRef = useRef(null);

  // const [currentPage, setCurrentPage] = useState(1);
  //   const rowsPerPage = 5;
  
    
  //   const indexOfLastRow = currentPage * rowsPerPage;
  //   const indexOfFirstRow = indexOfLastRow - rowsPerPage;
   
  
    
  
  //    const nextPage = () => {
  //     if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  //   };
  
  //   const prevPage = () => {
  //     if (currentPage > 1) setCurrentPage(currentPage - 1);
  //   };

  useEffect(() => {
      const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
          setShowDropdown(false);
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, []);

     const modules = {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      [{ font: [] }],
      [{ size: [] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ['link', 'image'],
      ['clean'],
    ],
  }

   const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  const handleBack = () => {
    if (location.state?.from === "dashboard") {
      navigate("/mail");
    } else {
      navigate("/campaign");
    }
  };
  
  const fetchTemplates = async () => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(`${baseURL}/api/get-templates`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    setTemplates(response.data || []);
  } catch (error) {
   Swal.fire({
             icon: 'error',
             title: 'Error',
             text: 'Something went wrong!',
             confirmButtonColor: 'red',
           });
  }
};

useEffect(() => {
  fetchTemplates();
}, []);

const handleUseTemplate = (template) => {
    navigate("/campaign", { state: { selectedTemplate: template } });
  };

    const handleSaveTemplate = async () => {
    
        const token = localStorage.getItem('token');
    
        if (!templateMessage.trim()) return  Swal.fire({
        icon: 'warning',
        title: 'Empty Message',
        text: 'Message cannot be empty.',
         confirmButtonColor:"#FCB124",
        willOpen: () => {
          document.querySelector('.swal2-container').style.zIndex = '3000';
        }
      });;
    
        const response = await fetch(`${baseURL}/api/save-template`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
          },
          body: JSON.stringify({
            name: templateName || null,
            message: templateMessage,
          }),
        });
    
        const data = await response.json();
        if (response.ok) {
          Swal.fire({
             icon: "success",
            text: `Template "${data.template.name}" saved successfully`,
            confirmButtonColor: "#FCB124",
            confirmButtonText: "OK",
            willOpen: () => {
          document.querySelector('.swal2-container').style.zIndex = '3000';
        }
          })
          setIsOpen(false);
          setTemplateMessage('');
          setTemplateName('');
          fetchTemplates();
        } else {
          Swal.fire({
            icon:"warning",
            text:`${data.message}`,
            confirmButtonColor:"#FCB124",
            confirmButtonText:"OK",
            willOpen: () => {
          document.querySelector('.swal2-container').style.zIndex = '3000';
        }
          })
        }
      };

       const handleInsertText = (text) => {
  if (!quillRef.current) return;

  const quill = quillRef.current.getEditor(); // get Quill editor instance
  const range = quill.getSelection();

  if (range) {
    quill.insertText(range.index, text); // insert variable at cursor
    quill.setSelection(range.index + text.length); // move cursor after inserted text
  } else {
    // if no selection, just append at the end
    quill.insertText(quill.getLength() - 1, text);
  }
};
    
  return (
    <div className='email-form-container'>
       <div className='email-campaign'>
                <div className='campaign'> <IoMdArrowBack style={{fontSize:"25px", cursor:"pointer"}}
                 onClick={handleBack} />My Templates </div> 
                   <div className='date-template'  ref={dropdownRef} style={{ position: "relative" }}>
                             <button className='camp-btn' onClick={toggleDropdown} >
                               <IoIosAdd style={{ fontSize: "32px", fontWeight: "500"}} /> Create Template
                             </button>
                              {showDropdown && (
                         <div
                           className="dropdown-menu"
                           style={{
                             position: "absolute",
                             top: "40px", 
                             right: "20px",
                             background: "#fff",
                             width:"200px",
                             border: "1px solid #ddd",
                             borderRadius: "4px",
                             boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                             zIndex: "1000",
                           }}
                         >
                           <div style={{ margin: 0, padding: "10px 0" }}>
                             <div style={{ padding: "8px 20px", cursor: "pointer", fontSize:"15px", fontWeight:"500" }}
                              onClick={() => {
                     openModal();      
                     setShowDropdown(false); 
                   }}>New Template</div>
                             <div style={{ padding: "8px 20px", cursor: "pointer" , fontSize:"15px", fontWeight:"500"}} onClick={() => navigate("/template", { state: { from: "campaign" } })}>Template Library</div>
                             <div style={{ padding: "8px 20px", cursor: "pointer", fontSize:"15px", fontWeight:"500" }} onClick={() => navigate("/mytemplate", { state: { from: "campaign" } })}>My Templates</div>
                           </div>
                         </div>
                       )}
                           </div> 
                            {isOpen && (
                                   <div className="modal-overlay">
                                     <div className="modal-content" ref={popupRef}>
                                       <div className='campaign' style={{textAlign:"left", fontSize:"15px",fontWeight:'500'}}><FaMailBulk/>
                                        &nbsp;Create Template</div>
                           
                                         <div  style={{marginTop:"20px", textAlign:"left", fontSize:"15px", marginLeft:"10px", }}>
                                           Template Name </div>
                                       <input
                                         type="text"
                                         placeholder="Enter your template name"
                                         style={{width:"560px", border:"0.2px solid rgba(0, 0, 0, 0.25)",
                                            height:"22px", borderRadius:"5px", marginTop:"20px", padding:"10px"}}
                                             value={templateName}
                                         onChange={(e) => setTemplateName(e.target.value)}
                                       />
                                        <select className="send-email-select" style={{width:"300px", height:"40px", borderRadius:"5px", marginTop:"20px", padding:"10px", marginLeft:"10px"}}
                                         onChange={(e) => handleInsertText(e.target.value)}
                                           defaultValue="">
                                        <option value="" disabled>Instant Variables</option>
                                       <option value="{{name}}">Name</option>
                                           <option value="{{date}}">Date</option>
                                           <option value="{{eSendEmailForm}}">SendEmailForm</option>
                                                    
                                      </select>
                                        {/* <textarea
                                      theme="snow"
                                   style={{width:"580px", height:"110px", marginTop:"10px", borderRadius:"5px", marginTop:"20px", marginLeft:"10px", border:"1px solid #ccc",}}
                                      placeholder="Enter your template message..."
                                   
                                     name="message"
                                      value={templateMessage}
                                         onChange={(e) => setTemplateMessage(e.target.value)}
                                         ref={textareaRef}
                                     
                                   /> */}
                                      <ReactQuill
                             ref={quillRef}
                             theme="snow"
                             style={{
                               width: "580px",
                               height: "110px",
                               borderRadius: "10px",
                               marginTop: "20px",
                               marginLeft: "10px"
                             }}
                             placeholder="Your Message"
                             className="sent-date-quill"
                             name="message"
                             value={templateMessage}
                             onChange={(content) => setTemplateMessage(content)} 
                             modules={modules}
                           />
                           
                           
                                       <div className="modal-actions">
                                         <button onClick={closeModal} className="cancel-temp-btn">
                                           Cancel
                                         </button>
                                         <button className="save-temp-btn" onClick={handleSaveTemplate}>Save</button>
                                       </div>
                                     </div>
                                   </div>
                                 )}
              </div>
      <div className="campaign-tablepagination">
          <table className="campaign-table">
            <thead>
              <tr>
                <th><input type="checkbox" /></th>
                <th>Template Name</th>
                <th>Preview</th>
                <th>Action</th>
              </tr>
            </thead>
             <tbody>
  {templates.length > 0 ? (
    templates.map((template, index) => (
      <tr key={index}>
        <td>
          <input type="checkbox" />
        </td>
        <td>{template.name}</td>
        <td>{template.message.length > 20 ? `${template.message.slice(0,50)}...`:template.message}</td>
        <td>
          <button className='use-temp-btn'  onClick={() => handleUseTemplate(template)}>Use Template</button>
        </td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="4">No templates available</td>
    </tr>
  )}
</tbody>
          </table>
          {/* <div style={{ marginTop: "20px" }} className='table-pagination'>
            <button onClick={prevPage} disabled={currentPage === 1} className="nav-button">
              Prev
            </button>
            <span style={{ margin: "0 10px" }}>
              Page {currentPage} of {totalPages}
            </span>
            <button onClick={nextPage} disabled={currentPage === totalPages} className="nav-button">
              Next
            </button>
          </div> */}
        </div>
    </div>
  )
}

export default MyTemplate
